<template>
  <AdapterSummary v-model="data" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapState } from 'vuex';
import {
  getAdapterDefaultValues,
  getAdapterHiddenFields,
} from '@aison/migrator/lib/utils';

import AdapterSummary from '@/components/summary/AdapterSummary.vue';

export default defineComponent({
  name: 'SourceSummary',
  components: {
    AdapterSummary,
  },
  computed: {
    ...mapState({
      type: (state: any) => state.source.type,
    }),
    ...mapGetters({
      summary: 'source/config',
    }),
    data() {
      const { type, adapter } = this.summary;
      const defaultValues = getAdapterDefaultValues(this.type);
      const config = { type, ...defaultValues, ...adapter };
      for (const key of getAdapterHiddenFields(this.type)) {
        if (config[key]) {
          config[key] = '********';
        }
      }

      return config;
    },
  },
});
</script>
